import Style from "./style"

import Pagenation from "widget/Pagenation"

import useGetAccountStoreTicketList from "entity/account/useGetAccountStoreTicketList"
import useGetAccountStoreTicketRecord from "entity/account/useGetAccountStoreTicketRecord"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertRecordTypeAsName } from "shared/constant/lookup/recordType"

const StoreTicket = () => {
    const [ticketList] = useGetAccountStoreTicketList()
    const [ticketRecord] = useGetAccountStoreTicketRecord()

    const sizeList = ["short", "longlonglong", "expand", "short"]
    const tableHeadList = ["IDX", "프렌차이즈", "매장 이용권 이름", "개수"]

    const recordSizeList = ["short", "longlonglong", "long", "expand", "medium", "short", "long"]
    const recordTableHeadList = ["IDX", "프렌차이즈", "매장", "대회", "분류", "개수", "기록 날짜"]

    return (
        <Style.Wrapper>

            <Style.Area>
                <h2>보유</h2>

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {ticketList?.data?.store_ticket_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.franchise_name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{elem?.ticket_name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{elem?.ticket_number}</TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>
            </Style.Area>

            <Style.Area $expand>
                <h2>사용 기록</h2>

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {recordTableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={recordSizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {ticketRecord?.data?.store_ticket_record?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={recordSizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[1]}>{elem?.franchise_name}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[2]}>{elem?.store_name}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[3]}>{elem?.event_name || "-"}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[4]}>{convertRecordTypeAsName[elem?.ticket_record_type_flag]}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[5]}>{elem?.number}</TStyle.Data>
                            <TStyle.Data $size={recordSizeList[6]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>

                <Pagenation maxPage={1} />
            </Style.Area>

        </Style.Wrapper>
    )
}

export default StoreTicket